import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(findCountry),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doGetScheduleId),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doHandlePostVerification),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadData),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(doVerifyCodeOperation),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(doSubmitNumberOperation),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(doPhoneVerificationOperation),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(userNeedsPhoneVerification),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(watchPhoneVerificationSagas);

import { push as updatePath } from 'react-router-redux';
import { defineMessages } from 'react-intl';
import { createFormAction } from 'redux-form-saga';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { change, initialize, SubmissionError } from 'redux-form';
import { call, fork, put, select, spawn, takeEvery } from 'redux-saga/effects';
import { getCountries, isUserVerified } from 'redux/saga/entities/bound';
import { selectScheduleId, setScheduleId } from 'redux/modules/features/venue-detail';
import { ec, ga } from 'helpers/multitrack';
import { augmentSubmitActionWithAdditionalData } from 'helpers/forms';
import { deepExtract } from 'helpers/deep';
import Base64Deriver from 'derivers/Base64';
import { shouldSkipPhoneVerification } from 'redux/saga/selectors/phoneVerification';
import { pathSelector } from 'redux/saga/selectors/request';
import { isLoggedIn } from 'redux/saga/selectors/user';
import { skipPhoneVerification } from 'redux/modules/features/phone-verification';
import { ALREADY_VERIFIED, CODE_ERROR, DELIVERY_METHOD_VOICE, DELIVERY_METHOD_SMS, DUPLICATE_NUMBER, DUPLICATE_NUMBER_ERROR, ERROR_CODE_MAPPING } from './PhoneVerification.constants';
var ITEM_CODE = 'Code';
var ITEM_PHONE = 'Phone';
export var messages = defineMessages({
  duplicateNumber: {
    id: 'phoneVerification.numberAlreadyAssociated',
    defaultMessage: 'That number is already associated with an account. Please verify the number and try again or reach out to our support team to complete your subscription.'
  }
});
export var LOAD_PHONE_VERIFICATION_PAGE = 'classpass/phoneVerification:LOAD_DATA';
export var CODE_VERIFICATION_FORM_NAME = 'verify-phone-code';
export var PHONE_VERIFICATION_FORM_NAME = 'verify-phone-number';
export var loadData = function loadData(countryCode, params) {
  return {
    type: LOAD_PHONE_VERIFICATION_PAGE,
    countryCode: countryCode,
    params: params
  };
};
export var submitPhoneNumber = createFormAction('submitPhoneNumber');
export var submitPhoneNumberAndText = augmentSubmitActionWithAdditionalData(submitPhoneNumber, {
  deliveryMethod: DELIVERY_METHOD_SMS
});
export var submitPhoneNumberAndCall = augmentSubmitActionWithAdditionalData(submitPhoneNumber, {
  deliveryMethod: DELIVERY_METHOD_VOICE
});
export var retryText = augmentSubmitActionWithAdditionalData(submitPhoneNumber, {
  deliveryMethod: DELIVERY_METHOD_SMS,
  retry: true
});
export var retryCall = augmentSubmitActionWithAdditionalData(submitPhoneNumber, {
  deliveryMethod: DELIVERY_METHOD_VOICE,
  retry: true
});
export var verifyCode = createFormAction('verifyCode');
export function findCountry(key, value) {
  var countries;
  return regeneratorRuntime.wrap(function findCountry$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getCountries.data);

        case 2:
          countries = _context.sent;
          return _context.abrupt("return", countries.find(function (country) {
            return String(country[key]) === value;
          }));

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doGetScheduleId(params) {
  var _deepExtract, _deepExtract2, encodedScheduleId, scheduleId;

  return regeneratorRuntime.wrap(function doGetScheduleId$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _deepExtract = deepExtract('splat', params, []), _deepExtract2 = _slicedToArray(_deepExtract, 2), encodedScheduleId = _deepExtract2[1];
          scheduleId = Base64Deriver.decodeNumber(encodedScheduleId);
          _context2.next = 4;
          return put(setScheduleId(scheduleId || 0));

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function doHandlePostVerification() {
  var path;
  return regeneratorRuntime.wrap(function doHandlePostVerification$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(isUserVerified.resetAction());

        case 2:
          _context3.next = 4;
          return select(pathSelector);

        case 4:
          path = _context3.sent;
          _context3.next = 7;
          return put(updatePath(path.replace(/^\/[^/]+(\/enter-code)?/, '/purchase')));

        case 7:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function doLoadData(client, _ref) {
  var countryCode, params, countries, countryId;
  return regeneratorRuntime.wrap(function doLoadData$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          countryCode = _ref.countryCode, params = _ref.params;
          _context4.prev = 1;
          _context4.next = 4;
          return call(doGetScheduleId, params);

        case 4:
          _context4.next = 6;
          return call(fetchEntityIfNeeded, getCountries, [client]);

        case 6:
          countries = _context4.sent;
          countryId = countries.find(function (country) {
            return country.code === countryCode;
          }).id;
          _context4.next = 10;
          return put(change(PHONE_VERIFICATION_FORM_NAME, 'countryId', String(countryId)));

        case 10:
          _context4.next = 18;
          break;

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 16;
          return put(skipPhoneVerification());

        case 16:
          _context4.next = 18;
          return call(doHandlePostVerification);

        case 18:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 12]]);
}
export function doVerifyCodeOperation(client, _ref2) {
  var code, countryCallingCode, phoneNumber;
  return regeneratorRuntime.wrap(function doVerifyCodeOperation$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          code = _ref2.code, countryCallingCode = _ref2.countryCallingCode, phoneNumber = _ref2.phoneNumber;
          _context5.next = 3;
          return call(client.phoneVerification.checkValidationCode, {
            code: code,
            country_code: countryCallingCode,
            phone_number: phoneNumber
          });

        case 3:
          _context5.next = 5;
          return call(doHandlePostVerification);

        case 5:
          _context5.next = 7;
          return spawn(ga, 'Membership Purchase', 'Phone Verification Code Input');

        case 7:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
export function doSubmitNumberOperation(client, _ref3) {
  var countryId, deliveryMethod, phoneNumber, retry, country, response, path;
  return regeneratorRuntime.wrap(function doSubmitNumberOperation$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          countryId = _ref3.countryId, deliveryMethod = _ref3.deliveryMethod, phoneNumber = _ref3.phoneNumber, retry = _ref3.retry;
          _context6.next = 3;
          return call(findCountry, 'id', countryId);

        case 3:
          country = _context6.sent;
          _context6.next = 6;
          return call(client.phoneVerification.sendValidationCode, {
            country_code: country.calling_code,
            delivery_method: deliveryMethod.toLowerCase(),
            phone_number: phoneNumber
          });

        case 6:
          response = _context6.sent;
          _context6.next = 9;
          return spawn(ga, 'Membership Purchase', 'Phone Verification Submit Number');

        case 9:
          if (!(response.status === ALREADY_VERIFIED)) {
            _context6.next = 13;
            break;
          }

          _context6.next = 12;
          return call(doHandlePostVerification);

        case 12:
          return _context6.abrupt("return");

        case 13:
          if (retry) {
            _context6.next = 21;
            break;
          }

          _context6.next = 16;
          return put(initialize(CODE_VERIFICATION_FORM_NAME, {
            countryCallingCode: country.calling_code,
            countryShortCode: country.short_code,
            phoneNumber: phoneNumber
          }));

        case 16:
          _context6.next = 18;
          return select(pathSelector);

        case 18:
          path = _context6.sent;
          _context6.next = 21;
          return put(updatePath(path.replace(/^(\/[^/]+)/, '$1/enter-code')));

        case 21:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
export function doPhoneVerificationOperation(client, form, item, operation, _ref4) {
  var payload, error, httpStatus, message, eventAction, scheduleId, action;
  return regeneratorRuntime.wrap(function doPhoneVerificationOperation$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _ref4.payload;
          _context7.prev = 1;
          _context7.next = 4;
          return call(operation, client, payload);

        case 4:
          _context7.next = 6;
          return put(form.success());

        case 6:
          _context7.next = 28;
          break;

        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7["catch"](1);
          httpStatus = _context7.t0.httpStatus, message = _context7.t0.message;
          error = ERROR_CODE_MAPPING[httpStatus] || {
            message: message
          };

          if (!(httpStatus === 403)) {
            _context7.next = 20;
            break;
          }

          eventAction = CODE_ERROR; // As a 403 can be returned for multiple reasons, when the
          // err.message is 'Duplicate Number' we want to display a more helpful
          // to the user rather than the ERROR_CODE_MAPPING value

          if (_context7.t0.message === DUPLICATE_NUMBER) {
            error = messages.duplicateNumber;
            eventAction = DUPLICATE_NUMBER_ERROR;
          }

          _context7.next = 17;
          return select(selectScheduleId);

        case 17:
          scheduleId = _context7.sent;
          _context7.next = 20;
          return spawn(ga, 'Membership Purchase', eventAction, scheduleId);

        case 20:
          if (ERROR_CODE_MAPPING[httpStatus]) {
            _context7.next = 26;
            break;
          }

          _context7.next = 23;
          return put(form.success());

        case 23:
          _context7.next = 25;
          return call(doHandlePostVerification);

        case 25:
          return _context7.abrupt("return");

        case 26:
          _context7.next = 28;
          return put(form.failure(new SubmissionError({
            _error: error
          })));

        case 28:
          _context7.prev = 28;

          if (item === ITEM_PHONE) {
            action = "".concat(payload.retry ? 'retry_' : '').concat(payload.deliveryMethod === DELIVERY_METHOD_SMS ? 'sms' : 'call');
          }

          _context7.next = 32;
          return spawn(ec, "Verify Phone - Submit ".concat(item), _objectSpread({}, error && {
            error: error.message || error.defaultMessage
          }, {
            action: action
          }));

        case 32:
          return _context7.finish(28);

        case 33:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[1, 8, 28, 33]]);
}
export function userNeedsPhoneVerification(client) {
  var shouldVerify, isVerified;
  return regeneratorRuntime.wrap(function userNeedsPhoneVerification$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return select(shouldSkipPhoneVerification);

        case 2:
          shouldVerify = !_context8.sent;

          if (shouldVerify) {
            _context8.next = 5;
            break;
          }

          return _context8.abrupt("return", false);

        case 5:
          _context8.next = 7;
          return select(isLoggedIn);

        case 7:
          _context8.t0 = _context8.sent;

          if (!_context8.t0) {
            _context8.next = 12;
            break;
          }

          _context8.next = 11;
          return call(fetchEntityIfNeeded, isUserVerified, [client]);

        case 11:
          _context8.t0 = _context8.sent;

        case 12:
          isVerified = _context8.t0;
          return _context8.abrupt("return", !isVerified);

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
export function watchPhoneVerificationSagas(client) {
  return regeneratorRuntime.wrap(function watchPhoneVerificationSagas$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return fork(takeEvery, LOAD_PHONE_VERIFICATION_PAGE, doLoadData, client);

        case 2:
          _context9.next = 4;
          return fork(takeEvery, submitPhoneNumber.REQUEST, doPhoneVerificationOperation, client, submitPhoneNumber, ITEM_PHONE, doSubmitNumberOperation);

        case 4:
          _context9.next = 6;
          return fork(takeEvery, verifyCode.REQUEST, doPhoneVerificationOperation, client, verifyCode, ITEM_CODE, doVerifyCodeOperation);

        case 6:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}